module.exports = __webpack_public_path__ + "img/capacity-01.3c122d10.png";